// src/pages/ProductPage.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ProductCard from '../components/specific/ProductCard';
import Button from '../components/common/Button';
import './ProductPage.css';

const ProductPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    // Simulate API call
    const fetchProducts = async () => {
      try {
        setLoading(true);
        // In a real app, this would be an API call
        const mockProducts = [
          {
            id: 1,
            name: 'Wireless Headphones',
            price: 99.99,
            image: '/images/headphones.jpg',
            category: 'electronics',
            rating: 4.5,
          },
          {
            id: 2,
            name: 'Smart Watch',
            price: 199.99,
            image: '/images/watch.jpg',
            category: 'electronics',
            rating: 4.2,
          },
          {
            id: 3,
            name: 'Cotton T-Shirt',
            price: 24.99,
            image: '/images/tshirt.jpg',
            category: 'clothing',
            rating: 4.0,
          },
          {
            id: 4,
            name: 'Running Shoes',
            price: 89.99,
            image: '/images/shoes.jpg',
            category: 'footwear',
            rating: 4.7,
          },
        ];
        
        setTimeout(() => {
          setProducts(mockProducts);
          setLoading(false);
        }, 1000);
      } catch (error) {
        console.error('Error fetching products:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = filter === 'all' 
    ? products 
    : products.filter(product => product.category === filter);

  const categories = ['all', 'electronics', 'clothing', 'footwear'];

  if (loading) {
    return (
      <div className="product-page loading">
        <div className="loading-spinner"></div>
        <p>Loading products...</p>
      </div>
    );
  }

  return (
    <div className="product-page">
      <div className="page-header">
        <h1>Our Products</h1>
        <p>Discover our curated collection of premium products</p>
      </div>

      <div className="filters">
        {categories.map(category => (
          <Button
            key={category}
            onClick={() => setFilter(category)}
            variant={filter === category ? 'primary' : 'outline'}
            className="filter-btn"
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </Button>
        ))}
      </div>

      <div className="products-grid">
        {filteredProducts.length > 0 ? (
          filteredProducts.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              isAuthenticated={isAuthenticated}
            />
          ))
        ) : (
          <div className="no-products">
            <p>No products found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductPage;